/****************************************************************************************
 * File Name    : FinishedViewer.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div class="report-viewer" id="print">
        <div @click="handlerForCloseDrawer()" class="report-viewer-close-btn" style="position:absolute; top:4px; right:18px; cursor:pointer; font-size:34px; font-weight:bold; -webkit-text-stroke:1px #fff; background-color:#eee;     border:1px solid #ccc;     padding:0 10px; line-height: 1.2; border-radius:4px; z-index:10;">X</div>
        <div v-if = "flagSpinner === false">
            <div v-if="showSaveBtn" title = "" style="position:relative;">
                <div class="report-header">
                    <div class="report-title">{{ target.title }}</div>
                    <div class="report-info-container">
                        <div class="report-info-group">
                            <div class="report-info-label">작성일자</div>
                            <div class="report-info-value">{{ target.updated.substr(0, 10) }}</div>
                        </div>
                        <div class="report-info-group">
                            <div class="report-info-label">소속(라인)</div>
                            <div class="report-info-value">{{ target.line }}</div>
                        </div>
                        <div class="report-info-group">
                            <div class="report-info-label">점검자</div>
                            <div class="report-info-value">
                                {{ target.manager }} 
                                <div style="display: inline-block; margin-left: 10px; border: 1px dashed #ccc; padding: 0 5px;">
                                    <img v-if="signatureImage" :src="signatureImage" style="max-height: 30px; max-width: 60px;" @click.stop="viewSignature" />
                                </div>
                            </div>
                        </div>
                        <div class="report-info-group">
                            <div class="report-info-label">승인자</div>
                            <div class="report-info-value">{{ target.approver }}</div>
                        </div>
                    </div>
                </div>

                <table style="width:100%; border-collapse: collapse; margin-top:20px; table-layout:auto;">
                    <colgroup>
                        <col style="width:150px; min-width:150px; max-width:150px;">
                        <col>
                        <col style="width:80px">
                        <col style="min-width:200px">
                        <col style="width:150px">
                    </colgroup>
                    <tr>
                        <th colspan="2" style="border: 1px solid #e8e8e8; padding:8px; text-align:center; background-color:#586994; color:white; white-space: normal;">점검항목<br/>(○ 양호, △ 미흡, X 불량, N/A 해당없음)</th>
                        <th style="width:80px; border: 1px solid #e8e8e8; padding:8px; text-align:center; background-color:#586994; color:white;">점검<br/>결과</th>
                        <th style="min-width:200px; border: 1px solid #e8e8e8; padding:8px; text-align:center; background-color:#586994; color:white;">조치사항<br/>(점검결과 미흡 또는 불량 시 기재)</th>
                        <th style="width:150px; border: 1px solid #e8e8e8; padding:8px; text-align:center; background-color:#586994; color:white;">점검<br/>이미지</th>
                    </tr>
                    <tr v-for="(item, index) in groupedData" :key="index">
                        <td v-if="item._isFirstInGroup" :rowspan="item._rowspan" style="border: 1px solid #e8e8e8; padding:8px; text-align:center; vertical-align:middle; width:150px; max-width:150px; white-space: normal; word-break: normal; word-wrap: break-word; overflow-wrap: break-word;">{{item.inspectionTarget}}</td>
                        <td style="border: 1px solid #e8e8e8; padding:0 8px; height:45px; max-height:45px; text-align:left; white-space: normal; word-break: normal; word-wrap: break-word; overflow-wrap: break-word; overflow: hidden;">
                            <span style="display:inline-block; width:20px; text-align:center; vertical-align:top;">○</span>
                            <span style="display:inline-block; width:calc(100% - 25px); overflow: hidden; text-overflow: ellipsis; max-height: 39px;">{{item.inspectionName}}</span>
                        </td>
                        <td style="border: 1px solid #e8e8e8; padding:8px; text-align:center !important;">
                            <template v-if="item.listProductCSInpectionStandard && item.listProductCSInpectionStandard[0]">
                                {{item.listProductCSInpectionStandard[0].min}}
                            </template>
                        </td>
                        <td style="border: 1px solid #e8e8e8; padding:0 8px; height:45px; max-height:45px; overflow: hidden; text-overflow: ellipsis; white-space: normal; word-break: normal; word-wrap: break-word; overflow-wrap: break-word;">
                            <template v-if="item.listProductCSInpectionStandard && item.listProductCSInpectionStandard[0]">
                                <span style="display: inline-block; width: 100%; overflow: hidden; text-overflow: ellipsis; max-height: 39px;">{{item.listProductCSInpectionStandard[0].result}}</span>
                            </template>
                        </td>
                        <td style="border: 1px solid #e8e8e8; padding:8px; text-align:center; height:45px;">
                            <div v-html="inspectionImageList2(item._originalIndex)" style="display:flex; flex-direction:row; flex-wrap:wrap;"></div>
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #e8e8e8; padding:8px; text-align:center; height:90px;">기타 특이사항</td>
                        <td colspan="4" style="border: 1px solid #e8e8e8; padding:6px;">
                            <span style="display: inline-block; width: 100%; overflow: auto; white-space: pre-wrap; line-height: 1.5;">{{target.special_note}}</span>
                        </td>
                    </tr>
                </table>

                <div style="width:100%; margin-top:20px; text-align:center; padding:10px;">
                    <a-button type="default" size="default" style="border-radius: 4px; padding: 0 15px; height: 32px; line-height: 32px;" @click="handlerForCloseDrawer()">
                        <span style="display: inline-block; width: 20px; height: 20px; margin-right: 5px; background-color: #1890ff; color: white; border-radius: 50%; line-height: 20px; font-size: 14px;">+</span>
                        나가기
                    </a-button>
                    <a-button type="default" size="default" style="border-radius: 4px; padding: 0 15px; height: 32px; line-height: 32px; margin-left: 10px;" @click="print()">
                        <span style="display: inline-block; width: 20px; height: 20px; margin-right: 5px; background-color: #1890ff; color: white; border-radius: 50%; line-height: 20px; font-size: 14px;">+</span>
                        인쇄
                    </a-button>
                    <a-button v-if="target.state !== 'X'" type="primary" size="default" style="border-radius: 4px; padding: 0 15px; height: 32px; line-height: 32px; margin-left: 10px;" @click="handlerForCloseDrawer(target, 'X')">
                        <span style="display: inline-block; width: 20px; height: 20px; margin-right: 5px; background-color: white; color: #1890ff; border-radius: 50%; line-height: 20px; font-size: 14px;">+</span>
                        승인완료
                    </a-button>
                    <a-button v-if="target.state === 'X'" type="danger" size="default" style="border-radius: 4px; padding: 0 15px; height: 32px; line-height: 32px; margin-left: 10px;" @click="handlerForCloseDrawer(target, 'V')">
                        <span style="display: inline-block; width: 20px; height: 20px; margin-right: 5px; background-color: white; color: #f5222d; border-radius: 50%; line-height: 20px; font-size: 14px;">+</span>
                        승인완료 취소
                    </a-button>
                </div>
                
                <!-- 안전보건 준수사항 박스 -->
                <div style="margin-top: 30px;" v-if="!loading" v-html="safetyHTML"></div>
                <div style="margin-top: 30px; text-align: center;" v-else>
                    <a-spin tip="안전보건 정보를 불러오는 중..."></a-spin>
                </div>
            </div>
            <a-card v-if="!showSaveBtn" :title = "target.name">
                <!--  -->
                <div class = 'todo'>상품정보 출력방식 변경</div>
                <a-list item-layout="horizontal" :data-source="data">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta :description="productDescription">
                            <span slot="title">{{ item.title }}</span>
                            <a-avatar slot="avatar" :src="productImagePath" ref=""/>
                        </a-list-item-meta>
                    </a-list-item>
                </a-list>
                <!--  -->
                <a-divider type = 'horizontal' />
                <div class = 'todo'>점검정보 출력방식 변경, 정렬</div>
                <!-- {{target.listProductCSInpection}} -->
                <div v-for = "(item,offset) in target.listProductCSInpection" :key = "offset">
                    <a-tag color="#108ee9">점검대상 {{item.inspectionIndex}} </a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    {{item.inspectionTarget}}
                    <p/>
                    <a-tag color="#108ee9">점검항목 {{item.inspectionIndex}}-{{item.inspectionOffset}} </a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    {{item.inspectionName}}
                    <p/>
                    <div v-html="inspectionImageList(offset)"></div>
                    <p/>
                    <a-tag color="">점검기준</a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    <div v-for = "(item2,offset2) in item.listProductCSInpectionStandard" :key = "offset2" style="white-space: pre-line;">
                        {{item2.name}}
                        <!-- <div v-if="!pop">
                            {{item2.min}} ~ {{item2.max}}
                            <br>
                            {{item2.result}}
                        </div>
                        <div v-if="pop"> -->
                        <div v-if="showSaveBtn">
                            <select v-model="item2.min"   style="padding:4px; width: 70px" >
                                <option value="○"> ○ </option>
                                <option value="△"> △ </option>
                                <option value="X"> X </option>
                                <option value="N/A"> N/A </option>
                            </select>
                            <a-input v-model="item2.result" placeholder="" style="margin-left: 20px; width: 100px"/>
                            <select v-model="item2.max"   style="margin-left:5px; padding:4px; width: 50px" >
                                <option value=""></option><option value="mm">mm</option>
                                <option value="cm">cm</option>
                                <option value="mA">mA</option>
                                <option value="A">A</option>
                                <option value="mV">mV</option>
                                <option value="V">V</option>
                                <option value="W">W</option>
                                <option value="kW">kW</option>
                                <option value="Ω">Ω</option>
                                <option value="kΩ">kΩ</option>
                                <option value="MΩ">MΩ</option>
                                <option value="ml">ml</option>
                                <option value="l">l</option>
                                <option value="mg">mg</option>
                                <option value="g">g</option>
                                <option value="℃">℃</option>
                                <option value="ppm">ppm</option>
                            </select>
                            <!-- <a-input v-model="item2.min" placeholder="" style="width: 50px"/>
                            -
                            <a-input v-model="item2.max" placeholder="" style="width: 50px"/>
                            <br>
                            <a-input v-model="item2.result" placeholder="" style="width: 300px"/> -->
                        </div>
                    </div>
                    <p/>
                    <a-tag v-if="item.inspectionDescription" color="">설명</a-tag>
                    <!-- <a-divider type = 'vertical' /> -->
                    {{item.inspectionDescription}}
                    <a-divider type = 'horizontal' />
                </div>
            </a-card>
        </div>
        <a-skeleton v-else />
        <div id="image-viewer-container" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.3);">
            <div id="image-viewer" style="position:absolute; top:5%; left:5%; width:90%; height:90%; background-color:#fff; border:1px solid #ccc;">
                <div id="image-viewer-close" @click="imageViewerClose()" style="position:absolute; top:23px; right:20px; cursor:pointer; font-size:34px; font-weight:bold; -webkit-text-stroke:1px #fff; background-color:#eee;     border:1px solid #ccc;     padding:0 10px; line-height: 1.2; border-radius:4px;">X</div>
                <div id="image-viewer-content" style="height:100%; overflow:auto;"></div>
            </div>
        </div>
        <div id="ng-note-container" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.3);">	
            <div id="ng-note" style="position:absolute; top:20%; left:20%; width:60%; height:60%; background-color:#fff; border:1px solid #ccc;">	
                <div id="ng-note-close" @click="ngNoteClose()" style="position:absolute; top:10px; right:20px; cursor:pointer; font-size:30px; font-weight:bold; z-index:10;">X</div>	
                <a-card title = "NG 기록하기">	
                    <a-input v-model="ngTitle" placeholder="제목" />	
                    <a-textarea v-model="ngContent" placeholder="NG 내용 기록" rows="17" style="margin-top:20px;"></a-textarea>	
                    <div style="margin-top:20px; text-align:center;">	
                        <a-button @click="ngNoteClose()" type="default" icon="plus-circle" size = "default" >	
                            취소	
                        </a-button>	
                        <a-button @click="saveNgNote()" type="primary" icon="plus-circle" size = "default" style="margin-left:20px;">	
                            완료	
                        </a-button>	
                    </div>	
                </a-card>	
            </div>	
        </div>
        <div id="signature-viewer-container" style="display:none; position:absolute; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.3); z-index:1000;">
            <div style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); max-width:80%; max-height:80%; background-color:#fff; border:1px solid #ccc; padding:20px; box-shadow:0 4px 12px rgba(0,0,0,0.15);">
                <div style="position:absolute; top:10px; right:10px; cursor:pointer; font-size:18px; font-weight:bold;" @click="closeSignatureViewer">×</div>
                <img :src="signatureImage" style="max-width:100%; max-height:100%;" />
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import $ from "jquery";
const data = [{title:'제품명'}];
export default {
    name: 'SafetyReportViewer',
    props : ['target', 'flagForDrawer', 'pop', 'showSaveBtn', 'showConfirmBtn'],
    components: {
    },
    data() {
        return {
            flagSpinner : false,
            data,
            fileUploadSeq   : 0,
            fileUploadItem : null,
            ngTitle: '',	
            ngContent: '',	
            offset: 0,	
            offset2: 0,
            uploadFileSeq: [],
            image1Src: '',
            image2Src: '',
            groupedData: [], // 그룹화된 데이터를 저장할 배열
            signatureImage: null,
            safetyHTML: '',
            loading: true,
            
            // 안전보건 준수사항
            safetyContent: {
                title: '',
                leftItems: [],
                rightItems: [],
                unsafeActionDesc: '',
                footerNote: ''
            },
            
            // 점검자 업무
            supervisorContent: {
                title: '',
                items: []
            },
            
            // 작업시작 전 점검사항
            inspectionContent: {
                title: '',
                categories: []
            },
            
            // 하단 문구
            footerPhrase: ''
        };
    },
    mounted() {
        this.setListProductCSInpection();
        this.groupInspectionData();
        
        // 서명 데이터 조회
        this.fetchSignatureData();

        if (this.target.image1) {
            this.image1Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image1;
            console.log(this.image1Src)
        } else {
            this.image1Src = '';
        }

        if (this.target.image2) {
            this.image2Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image2;
        } else {
            this.image2Src = '';
        }

        // DB에서 안전보건 데이터 가져오기
        this.fetchSafetyContent();
    },
    watch: {
        target: function(newOne){
            this.target = newOne;

            if (this.target.image1) {
                this.image1Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image1;
                console.log(this.image1Src)
            } else {
                this.image1Src = '';
            }

            if (this.target.image2) {
                this.image2Src = this.$store.state.hostInService +'/upload/image/download/' + this.target.image2;
            } else {
                this.image2Src = '';
            }

            this.setListProductCSInpection();
            this.groupInspectionData();
            
            // 서명 데이터 조회
            this.fetchSignatureData();
        }
    },
    computed : {
        productDescription() {
            let buffer = this.target.clsProduct.productName + " (" + this.target.clsProduct.productModel + ") ";
            for(let x = 0; x < this.target.clsProduct.listProductFunction.length; x ++ ) {
                buffer = buffer + this.target.clsProduct.listProductFunction[x].productFunctionName + ",";
            }
            return buffer;
        },
        productImagePath() {
            return this.$store.state.hostInService + '/upload/image/download/' + this.target.clsProduct.uploadFileSeq;
        },

    },
    methods : {
        // 점검항목별로 데이터를 그룹화하는 메서드
        groupInspectionData() {
            if (!this.target || !this.target.listProductCSInpection) return;
            
            const data = [...this.target.listProductCSInpection];
            this.groupedData = [];
            
            // 데이터를 점검항목별로 그룹화
            const groups = _.groupBy(data, 'inspectionTarget');
            
            // 각 그룹의 시작 인덱스와 rowspan 값을 계산
            let currentIndex = 0;
            
            Object.entries(groups).forEach(([, items]) => {
                const groupLength = items.length;
                
                // 각 그룹의 첫 번째 항목에 rowspan 정보 추가
                for (let i = 0; i < groupLength; i++) {
                    const item = items[i];
                    if (i === 0) {
                        // 첫 번째 항목에는 그룹 관련 정보를 추가
                        this.groupedData.push({
                            ...item,
                            _isFirstInGroup: true,
                            _rowspan: groupLength,
                            _originalIndex: currentIndex
                        });
                    } else {
                        // 나머지 항목은 그대로 추가
                        this.groupedData.push({
                            ...item,
                            _isFirstInGroup: false,
                            _originalIndex: currentIndex + i
                        });
                    }
                }
                
                currentIndex += groupLength;
            });
        },
        // 기존의 정렬 메서드
        setListProductCSInpection() {
            this.target.listProductCSInpection = _.sortBy(this.target.listProductCSInpection, ['inspectionIndex', 'inspectionOffset']);

            let isEven = false;
            let oldInspectionIndex = '';
            _.forEach(this.target.listProductCSInpection, (item) => {
                if (!oldInspectionIndex) {
                    oldInspectionIndex = item.inspectionIndex;
                }

                if (item.inspectionIndex !== oldInspectionIndex) {
                    oldInspectionIndex = item.oldInspectionIndex;

                    isEven = !isEven;
                }

                item.isEven = isEven;
            });
        },
        inspectionImageList(offset) {
            let self = this;

            let html = '';
            let imageSeq = [];
            if (this.target.listProductCSInpection[offset].inspectionImageSeq && this.target.listProductCSInpection[offset].inspectionImageSeq != '0') {
                imageSeq = this.target.listProductCSInpection[offset].inspectionImageSeq.split('||');
            }

            _.forEach(imageSeq, (item, i) => {
                if (i > 4) {    // 최대 5장 표시
                    return;
                }

                let src = this.$store.state.hostInService +'/upload/image/download/' + item;
                html += '<a href = "' + src + '" target="_blank" id="view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item + '"><img src = "' + src + '" style = "max-width:40px; height:30px;"/></a>';

                ((self) => {
                    // 이미지 보기
                    $('body').off('click.view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item).on('click.view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item, '#view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item , function(e) {
                        e.preventDefault();

                        let html = '<p style="margin:20px; text-align:center;"><img src = "' + src + '" style = "max-width:100%;"/></p>';

                        self.viewInspectionImage2(html);
                    });
                })(self);
            });

            return html;
        },
        inspectionImageList2(offset) {
            let self = this;

            let html = '';
            let imageSeq = [];
            if (this.target.listProductCSInpection[offset].inspectionImage2Seq && this.target.listProductCSInpection[offset].inspectionImage2Seq != '0') {
                imageSeq = this.target.listProductCSInpection[offset].inspectionImage2Seq.split('||');
            }

            imageSeq = imageSeq.filter(item => item !== '0');
            
            // 테이블 구조로 가로 정렬 강제
            html += '<table style="width:100%; border-collapse:collapse;"><tr>';
            
            _.forEach(imageSeq, (item, i) => {
                if (i > 2) {    // 최대 3장 표시
                    return;
                }

                let src = this.$store.state.hostInService +'/upload/image/download/' + item;
                html += '<td style="padding:2px; text-align:center;"><a href = "' + src + '" target="_blank" id="view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item + '"><img src = "' + src + '" style = "max-width:40px; height:24px;"/></a></td>';

                ((self) => {
                    // 이미지 보기
                    $('body').off('click.view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item).on('click.view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item, '#view-image-' + self.target.listProductCSInpection[offset].produtCsInspectionSeq + '-' + item , function(e) {
                        e.preventDefault();

                        let html = '<p style="margin:20px; text-align:center;"><img src = "' + src + '" style = "max-width:100%;"/></p>';

                        self.viewInspectionImage2(html);
                    });
                })(self);
            });
            
            html += '</tr></table>';
            return html;
        },
        productInspectionPath(offset) {
            return this.$store.state.hostInService +'/upload/image/download/' + this.target.listProductCSInpection[offset].inspectionImageSeq;
        },
        productInspectionPath2(offset) {
            return this.$store.state.hostInService +'/upload/image/download/' + this.target.listProductCSInpection[offset].inspectionImage2Seq;
        },
        handlerForCloseDrawer(target, state) {
            this.$emit('flagForDrawer');

            if (target) {
                let message = '';
                if (target.state !== 'X') {
                    message = target.updated.substr(0, 10) + ' ' + target.title + ' 승인하시겠습니까?';
                } else {
                    message = target.updated.substr(0, 10) + ' ' + target.title + ' 승인취소하시겠습니까?';
                }
                if (confirm(message)) {
                    this.$emit('editSafetyCS', target, state);
                }
            }
        },
        imageUpload(info) {
            this.spinning = info.file.status === 'uploading' ? true : false;
            if(info.file.status === 'done') {
                this.$message.success(`${info.file.name} file uploaded successfully`);
                this.uploadFileSeq.push(info.file.response.data.uploadFileSeq);
                this.fileUploadSeq = this.uploadFileSeq.join('||');
                this.fileUploadItem.inspectionImage2Seq = this.fileUploadSeq;
                
                // 이미지 리사이징 API 호출
                this.$http.post(`${this.$store.state.nodeApiUrl}/user/resize-image`, {
                    uploadFileSeq: info.file.response.data.uploadFileSeq
                })
                .then(response => {
                    if (response.data.code === 'success') {
                        console.log('✅ Image resized:', response.data.data);
                    }
                })
                .catch(error => {
                    console.error('❌ Resize failed:', error);
                });
            } else if(info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        },
        imageUpload2(item) {
            this.fileUploadItem = item;
        },
        viewInspectionImage(src) {
            // window.open('image-viewer.html?src=' + src);
            document.getElementById('image-viewer-container').style.display = 'block';
            document.getElementById('image-viewer-img').src = src;
        },
        viewInspectionImage2(html) {
            document.getElementById('image-viewer-container').style.display = 'block';
            document.getElementById('image-viewer-content').innerHTML = html;
        },
        imageViewerClose() {
            document.getElementById('image-viewer-container').style.display = 'none';
            document.getElementById('image-viewer-content').innerHTML = '';
        },
        viewNgNote(offset, offset2) {	
            this.offset = offset;	
            this.offset2 = offset2;	
            var item = this.target.listProductCSInpection[offset].listProductCSInpectionStandard[offset2];	
            this.ngTitle = item.ngTitle;	
            this.ngContent = item.ngContent;	
            document.getElementById('ng-note-container').style.display = 'block';	
        },	
        saveNgNote() {	
            var item = this.target.listProductCSInpection[this.offset].listProductCSInpectionStandard[this.offset2];	
            item.ngTitle = this.ngTitle;	
            item.ngContent = this.ngContent;	
            this.ngNoteClose();	
        },	
        ngNoteClose() {	
            this.ngTitle = '';	
            this.ngContent = '';	
            document.getElementById('ng-note-container').style.display = 'none';	
        },
        print() {
            // Get HTML to print from element
            const prtHtml = document.getElementById('print').innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
            }

            // Open the print window
            const WinPrint = window.open('', '', 'left=0,top=0,width=1600,height=900,toolbar=0,scrollbars=0,status=0');

            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body style="zoom:0.7; padding-right: 2px;">
                ${prtHtml}
            </body>
            </html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.onload = function() {
                setTimeout(function() {
                    WinPrint.print();
                    WinPrint.close();
                }, 1000);
            };
        },
        fetchSignatureData() {
            if (!this.target || !this.target.productCsSeq) return;
            
            const apiUrl = this.$store.state.nodeApiUrl + '/product/cs/get_signature_data?productCsSeq=' + this.target.productCsSeq;
            
            this.$http.get(apiUrl)
                .then(response => {
                    if (response.status === 200 && response.data.code === 'success' && response.data.data) {
                        this.signatureImage = response.data.data;
                    } else {
                        this.signatureImage = null;
                    }
                })
                .catch(error => {
                    console.error('서명 데이터 조회 오류:', error);
                });
        },
        viewSignature() {
            document.getElementById('signature-viewer-container').style.display = 'block';
        },
        closeSignatureViewer() {
            document.getElementById('signature-viewer-container').style.display = 'none';
        },
        fetchSafetyContent() {
            this.loading = true;
            
            // API를 통해 데이터 불러오기
            this.$http.get(this.$store.state.nodeApiUrl + '/product/get_system_data')
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        let systemData = response.data.data.content[0];
                        
                        // DB에 저장된 데이터가 있으면 파싱해서 적용
                        if (systemData && systemData.safety_compliance) {
                            try {
                                const data = JSON.parse(systemData.safety_compliance);
                                this.safetyContent = data.safetyContent || this.safetyContent;
                                this.supervisorContent = data.supervisorContent || this.supervisorContent;
                                this.inspectionContent = data.inspectionContent || this.inspectionContent;
                                this.footerPhrase = data.footerPhrase || this.footerPhrase;
                                
                                // HTML 생성
                                this.generateSafetyHTML();
                            } catch (e) {
                                console.error('안전보건 콘텐츠 파싱 오류:', e);
                                this.useFallbackHTML();
                            }
                        } else {
                            this.useFallbackHTML();
                        }
                    } else {
                        console.error('시스템 데이터 조회 실패:', response);
                        this.useFallbackHTML();
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    console.error('시스템 데이터 조회 오류:', error);
                    this.useFallbackHTML();
                    this.loading = false;
                });
        },
        
        // 동적 HTML 생성
        generateSafetyHTML() {
            let html = `
<div style="margin-top: 30px;">
    <!-- 안전보건 준수사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#fffdf0; border: 1px solid #e5e5c9;">
        <tr>
            <td colspan="2" style="padding: 5px; text-align: center; font-weight: bold; font-size: 14px; border-bottom: 1px solid #e5e5c9;">${this.safetyContent.title}</td>
        </tr>
        <tr>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6; border-right: 1px solid #e5e5c9;">
                ${this.safetyContent.leftItems.map(item => `<div>${item}</div>`).join('')}
            </td>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6;">
                ${this.safetyContent.rightItems.map(item => `<div>${item}</div>`).join('')}
                ${this.safetyContent.unsafeActionDesc ? `<div style="color:#ff0000; font-size:11px; line-height:1.4;">${this.safetyContent.unsafeActionDesc}</div>` : ''}
            </td>
        </tr>
        <tr>
            <td colspan="2" style="padding:5px; text-align:center; font-size:11px; border-top: 1px solid #e5e5c9;">${this.safetyContent.footerNote}</td>
        </tr>
    </table>
    
    <!-- 점검자 업무 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#ffffff; border: 1px solid #e5e5c9; border-top: none;">
        <tr>
            <td style="padding:5px; text-align:center; font-size:11px; font-weight:bold;">${this.supervisorContent.title}</td>
        </tr>
        <tr>
            <td style="padding:5px 10px; font-size:11px; line-height:1.5;">
                ${this.supervisorContent.items.map(item => `<div style="margin-bottom:3px;">${item}</div>`).join('')}
            </td>
        </tr>
    </table>
    
    <!-- 점검자 작업시작 전 점검사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; margin-top:20px; border: 1px solid #e5e5c9; font-size:11px;">
        <tr>
            <td colspan="2" style="padding:6px; text-align:center; background-color:#f0f0f0; font-weight:bold; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.title}
            </td>
        </tr>`;
            
            // 카테고리를 2개씩 짝지어 행을 구성
            for (let i = 0; i < this.inspectionContent.categories.length; i += 2) {
                html += `
        <tr>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i]?.title || ''}
            </td>`;
                
                // 홀수 카테고리가 있는 경우
                if (i + 1 < this.inspectionContent.categories.length) {
                    html += `
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i + 1]?.title || ''}
            </td>`;
                } else {
                    // 마지막 홀수 카테고리인 경우 빈 셀 추가
                    html += `
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                
            </td>`;
                }
                
                html += `
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i]?.items.map(item => `<div>${item}</div>`).join('') || ''}
            </td>`;
                
                // 홀수 카테고리의 항목이 있는 경우
                if (i + 1 < this.inspectionContent.categories.length) {
                    html += `
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i + 1]?.items.map(item => `<div>${item}</div>`).join('') || ''}
            </td>`;
                } else {
                    // 마지막 홀수 카테고리인 경우 빈 셀 추가
                    html += `
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                
            </td>`;
                }
                
                html += `
        </tr>`;
            }
            
            html += `
    </table>
    
    <!-- 안전으로 시작해서 품질로 완성하는 문구 -->
    <div style="width:100%; text-align:center; margin-top:10px; font-weight:bold; color:#ff0000; font-size:13px;">
        ${this.footerPhrase}
    </div>
</div>
            `;
            
            this.safetyHTML = html;
        },
        
        // 데이터를 불러오지 못한 경우 기존 하드코딩된 HTML 사용
        useFallbackHTML() {
            this.safetyHTML = `
<div style="margin-top: 30px;">
    <!-- 안전보건 준수사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#fffdf0; border: 1px solid #e5e5c9;">
        <tr>
            <td colspan="2" style="padding: 5px; text-align: center; font-weight: bold; font-size: 14px; border-bottom: 1px solid #e5e5c9;">안전보건 준수사항</td>
        </tr>
        <tr>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6; border-right: 1px solid #e5e5c9;">
                <div>1. 작업시작 전 스트레칭 습관화</div>
                <div>2. 개인보호구 착용 철저</div>
                <div>3. 흡연장소 화재예방 준수</div>
                <div>4. 안전장치 임의해체 및 훼손 금지</div>
                <div style="padding-left:13px;">- 인터록장치, 광전차식용보장치, 비상정지장치 등</div>
                <div>5. 전기시설 및 태그 표시 확인</div>
                <div style="padding-left:13px;">- 정비, 청소, 사업교체 등 작업 시</div>
                <div>6. 지내 차량 저정속도 및 도보 시 보행로 이동 준수</div>
                <div style="padding-left:13px;">- 지정속도 : 10km 미만</div>
            </td>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6;">
                <div>7. 작업 중, 운전 중, 보행 중 유대전화 및 전자기기 사용 금지</div>
                <div>8. 안전작업허가제 준수 (미허가 안전작업 금지)</div>
                <div>9. 불안전한 행동 금지</div>
                <div style="color:#ff0000; font-size:11px; line-height:1.4;">※ 불안전한 행동 : 근무시간 준수, 컨베이어 등 설비 넘어다니거나, 가동중인 설비에 올라가는 행위, 지게차 포크 탑승, 지게차 사이 미확보, 작업과 관련없이 지정 및 설비 등에 올라는 행위(추락위험), 위험설비 작업반경 내 임의 출입 및 신체를 투입, 화학물질을 다른 용도로 사용하는 행위 등 재해를 유발하는 행위 등</div>
            </td>
        </tr>
        <tr>
            <td colspan="2" style="padding:5px; text-align:center; font-size:11px; border-top: 1px solid #e5e5c9;">※ 점검자 업무 및 작업시작 전 점검사항 확인 필수</td>
        </tr>
    </table>
    
    <!-- 점검자 업무 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#ffffff; border: 1px solid #e5e5c9; border-top: none;">
        <tr>
            <td style="padding:5px; text-align:center; font-size:11px; font-weight:bold;">점검자의 업무 (산업안전보건법 시행령 제15조)</td>
        </tr>
        <tr>
            <td style="padding:5px 10px; font-size:11px; line-height:1.5;">
                <div style="margin-bottom:3px;">① 산안법 제16조 제1항에 따른 점검자가 지휘·감독하는 업무와 관련된 기계·기구 또는 설비의 안전·보건 점검 및 이상유무 확인</div>
                <div style="margin-bottom:3px;">② 1)소속직원의 안전보건구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도</div>
                <div style="margin-bottom:3px;">③ 해당 업무(작업)에서 발생한 산업재해에 관한 보고 및 이에 대한 응급조치</div>
                <div style="margin-bottom:3px;">④ 해당 업무(작업)의 작업장 경리정돈 및 통로 확보에 관한 확인 및 감독</div>
                <div style="margin-bottom:3px;">⑤ 산업재해사 안전·보건관리자의 지도·조언에 대한 협조</div>
                <div style="margin-bottom:3px;">⑥ 산업안전보건법 제36조에 따라 위험방지에 관한 담금 작 특히 담무</div>
                <div style="margin-bottom:3px;">가. 투비, 웰딩공사의 화재에 대한 점검</div>
                <div style="margin-bottom:3px;">나. 개선조치 시행에 대한 참여</div>
                <div style="margin-bottom:3px;">⑦ 그 밖에 해당 업무(작업)의 안전·보건에 관한 사항으로서 사업장 및 고용노동부 등에서 결하는 사항</div>
            </td>
        </tr>
    </table>
    
    <!-- 점검자 작업시작 전 점검사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; margin-top:20px; border: 1px solid #e5e5c9; font-size:11px;">
        <tr>
            <td colspan="2" style="padding:6px; text-align:center; background-color:#f0f0f0; font-weight:bold; border-bottom: 1px solid #e5e5c9;">
                점검자 작업시작 전 점검사항 (제35조제2항 관련)
            </td>
        </tr>
        <tr>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                공통가자 반복하여 계속적으로 중량물을 취급하는 작업을 할 때
            </td>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                전동이어들을 사용하여 작업을 할 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 중량물 취급의 올바른 자세 및 방식</div>
                <div>나. 허리통이 낮아 둥글임에 따른 보호구의 착용</div>
                <div>다. 카바이드 · 생석회(산화칼슘) 등과 같이 온도상승이나 눌려와도 위험성이 존재하는 중량물의 취급방법</div>
                <div>라. 그 밖에 위적운반기구의 적절한 사용방법</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 핸드그리 및 롤러(roller) 기능의 이상 유무</div>
                <div>나. 이앙 둥의 방지장치 기능의 이상 유무</div>
                <div>다. 비상정지장치 기능의 이상 유무</div>
                <div>라. 펌프기 · 회전속 · 기어 및 롤러 등의 덮개 또는 울 등의 이상 유무</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                혼합 · 용단 작업 등의 화재위험작업을 할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                이동식 방폭구조(防爆構造) 전기기계 · 기구를 사용할 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 작업 준비 및 작업 절차 수립 여부</div>
                <div>나. 화기작업에 따른 인근 가연성물질 방호조치 및 소화기구 비치 여부</div>
                <div>다. 옷슬롯의 비산방지덮게 또는 옷롱방화포 등 불꽃 · 불티 등의 비산 방지장치 점검 조치 여부</div>
                <div>라. 인화성 액체의 증기 또는 인화성 가스가 남아 있지 않도록 환기 조치 여부</div>
                <div>마. 작업근로자에 대한 화재예방 및 피난교육 등 비상조치 여부</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 전선 및 접속부 상태</div>
                <div>나. 외부 전선의 피복 또는 외장의 손상 유무</div>
                <div>다. 매니플레이터(manipulator) 작동의 이상 유무</div>
                <div>라. 제동장치 및 비상정지장치의 기능</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                출입 통로 사용하여 작업을 할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                리프트(자동차정비용 리프트를 포함한다)를 사용하여 작업을 할 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 통이 불이 있는 출입 · 살아어올림 등이 배달된 상태</div>
                <div>나. 출입 · 살아어올림 등의 상태(작업시작 전 및 작업 중 수시로 확인)</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 방호장치 · 브레이크 및 클러치의 기능</div>
                <div>나. 와이어로프가 통하고 있는 곳의 상태</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                로봇의 작동 범위에서 그 로봇에 관하여 교시 등 작업을 할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                크레인을 사용하여 작업을 하는 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                <div>가. 외부 전선의 피복 또는 외장의 손상 유무</div>
                <div>나. 매니플레이터(manipulator) 작동의 이상 유무</div>
                <div>다. 제동장치 및 비상정지장치의 기능</div>
            </td>
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                <div>가. 권과방지장치 · 브레이크 · 클러치 및 운전장치의 기능</div>
                <div>나. 주변통의 상촉 및 트롤리(trolley)가 횡행하는 레일의 상태</div>
                <div>다. 와이어로프가 통하고 있는 곳의 상태</div>
            </td>
        </tr>
        <tr>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                공기압축기를 가동할 때
            </td>
            <td style="padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                지게차를 사용하여 작업을 하는 때
            </td>
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9;">
                <div>가. 공기압력 압력용기의 외관 상태</div>
                <div>나. 드레인밸브(drain valve)의 조작 및 배수</div>
                <div>다. 압력방출장치의 기능</div>
                <div>라. 언로딩밸브(unloading valve)의 기능</div>
                <div>마. 공동유의 상태</div>
                <div>바. 회전부의 덮개 또는 울</div>
                <div>사. 그 밖의 연결 부위의 이상 유무</div>
            </td>
            <td style="padding:6px; vertical-align:top;">
                <div>가. 제동장치 및 조향장치 기능의 이상 유무</div>
                <div>나. 하역장치 및 유압장치 기능의 이상 유무</div>
                <div>다. 바퀴의 이상 유무</div>
                <div>라. 전조등 · 후미등 · 방향지시기 및 경보장치 기능의 이상 유무</div>
            </td>
        </tr>
    </table>
    
    <!-- 안전으로 시작해서 품질로 완성하는 문구 -->
    <div style="width:100%; text-align:center; margin-top:10px; font-weight:bold; color:#ff0000; font-size:13px;">
        안전으로 시작해서 품질로 완성하는 우리는 생산/구매분부
    </div>
</div>
            `;
        }
    }
}
</script>
<style scoped>
    /* 헤더 스타일 */
    .report-header {
        width: 100%;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        border-radius: 6px;
        overflow: hidden;
        margin-bottom: 10px;
    }
    
    .report-title {
        width: 100%;
        background: linear-gradient(to right, #f0f0f0, #e0e0e0);
        color: #444444;
        font-size: 24px;
        padding: 15px;
        text-align: center;
        border: 1px solid #e0e0e0;
        font-weight: bold;
        text-shadow: 1px 1px 1px rgba(255,255,255,0.8);
    }
    
    .report-info-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        border-left: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        background-color: #f9f9f9;
    }
    
    .report-info-group {
        display: flex;
        flex: 1;
        min-width: 250px;
    }
    
    .report-info-label {
        background: linear-gradient(to bottom, #e8e8e8, #d8d8d8);
        color: #444444;
        padding: 10px;
        text-align: center;
        width: 90px;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
    }
    
    .report-info-value {
        padding: 10px 15px;
        text-align: center;
        flex: 1;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
    }
    
    /* 추가 스타일 - 세로 텍스트 방지 */
    [class*="col-"] {
        width: 100%;
        float: none;
        display: block;
    }
    
    td {
        direction: ltr !important;
        unicode-bidi: normal !important;
        writing-mode: horizontal-tb !important;
        text-orientation: mixed !important;
    }
    
    td[rowspan] {
        max-width: 150px !important;
        white-space: normal !important;
        word-break: break-word !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
    }
    
    .sheet-table th {
        font-weight: bold;
    }
    
    .sheet-table tr.even,
    .bg-even {	
        background-color: #e8f7ff;	
    }

    .border-left {
        border-left: 1px solid #e8e8e8;
    }

    .border-left-dashed {
        border-left: 1px dashed #e8e8e8;
    }

    .border-right {
        border-right: 1px solid #e8e8e8;
    }

    .sheet-table th {
        text-align: center;
        font-weight: bold;
    }

    .sheet-table tr th {
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
    }
    
    .sheet-table tr.even {	
        background-color: #e8f7ff;	
    }

    .sheet-table td {
        text-align: center;
        border-left: 1px solid #e8e8e8;
        word-break: keep-all;
        white-space: normal;
        word-wrap: break-word;
    }

    table {
        width: 100%;
        table-layout: fixed !important;
    }

    .sheet-table td.text-left {
        padding-left: 10px !important;
        padding-right: 10px !important;
        text-align: left;
    }

    .image-container img {
        max-width: 100%;
        width: auto;
        max-height: 600px;
        height: 100%;
        display: block;
        margin: 30px auto;
    }

    .sheet-table .ant-table-thead > tr > th,
    .sheet-table .ant-table-tbody > tr > td {
        padding-top: 0;
        padding-bottom: 0;
        height: 45px;
    }

    .sheet-table.header-table .ant-table-thead > tr > th,
    .sheet-table.header-table .ant-table-tbody > tr > td {
        height: 28px;
    }

    .sheet-table .ant-table-tbody > tr > td.value-container > div:has(div) {
        height: 40px;
        line-height: 30px;
    }
    .sheet-table .ant-table-tbody > tr > td.value-container div:first-child {
        border-left: none !important;
    }
</style>